import type { ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { BlotterAggFunc } from '../aggFuncs';
import { baseColumn } from './baseColumn';
import type { ColDefFactory, Column } from './types';

type RowCountValue = number;

/**
 * This column just counts the rows and aggregates them.
 *
 * This column will not show the row count on non-group (non-aggregated) rows (which always would be 1).
 */
export const rowCount: ColDefFactory<Column> = column => ({
  ...baseColumn({ ...column, exportable: false }),
  valueGetter: (params: ValueGetterParams<unknown>): RowCountValue => {
    return 1;
  },
  initialAggFunc: column.initialAggFunc ?? (column.aggregate ? BlotterAggFunc.RowCount : undefined),
  valueFormatter: (params: ValueFormatterParams<unknown, RowCountValue>) => {
    if (!params.value || !params.node?.group) {
      return '';
    }

    return params.value.toString();
  },
});
